import { render, staticRenderFns } from "./AttachImg.vue?vue&type=template&id=f3af66d8&scoped=true"
import script from "./AttachImg.vue?vue&type=script&lang=js"
export * from "./AttachImg.vue?vue&type=script&lang=js"
import style0 from "./AttachImg.vue?vue&type=style&index=0&id=f3af66d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3af66d8",
  null
  
)

export default component.exports